import header from "./gesetzbuch-mit-brille.jpg";
import section1de from "./calculation-process-din-277-de.webp";
import section1en from "./calculation-process-din-277.webp";
import section2 from "./attic-building-with-wooden-beams.jpg";
import section3 from "./weisser-ordner.jpg";
import section4 from "./photo-din-277.jpg";
import section5 from "./empty-room-with-plain-walls.jpg";
import section6 from "./house-din-277.jpg";

export {
  header,
  section1de,
  section1en,
  section2,
  section3,
  section4,
  section5,
  section6,
};
